import { Panel } from './Panel.js';

/** Required fiction disclaimer. Shown on the opening screen and in About. */
export function Disclaimer() {
  return (
    <Panel className="disclaimer" aria-labelledby="disclaimer-title">
      <h2 id="disclaimer-title" className="disclaimer__title">
        <span aria-hidden="true">📰</span> A Work of Fiction
      </h2>
      <p>
        This game is a work of satire and fiction. All characters, leaders, countries,
        organizations, events, and scenarios depicted in the game are fictional. Any resemblance to
        actual persons, living or dead, or actual events is purely coincidental. Similarities in
        names, appearances, or settings are intended as fictional parody and do not represent real
        individuals or events.
      </p>
    </Panel>
  );
}
